<div class="header">
  <div class="header-actions">
    <button class="t-button-outline" (click)="addSpellingCheckIgnoredOpenSw = true">
      {{ "translate.general.add" | translate }}
    </button>
  </div>
</div>
<loader *ngIf="loading"></loader>
<ui-table
  [isWrapped]="false"
  [data]="spellingCheckIgnored"
  [numberOfRows]="10"
  [displayFilter]="['wordId', 'word']"
  [templates]="[   
    {
      title: 'translate.general.isGlobal',
      template: isGlobal
    },
    {
      title: 'translate.general.actions',
      template: actions
    }

  ]"
></ui-table>

<ng-template #actions let-row="row">
  <a (click)="delete(row)">{{ "translate.general.delete" | translate }}</a>
</ng-template>
<ng-template #isGlobal let-row="row">
 <i class="fa" [ngClass]="row.isGlobal ? 'fa-check':'fa-times'"></i>
</ng-template>
<add-spelling-check-ignored
  *ngIf="addSpellingCheckIgnoredOpenSw"
  (onClose)="addSpellingCheckIgnoredOpenSw = false"
  (onAdd)="add($event)"
>
</add-spelling-check-ignored>
